import { combineReducers } from 'redux';
import createDSReducer from './createDSReducer'
import verifyDSReducer from './verifyDSReducer'


const baseState = {
    signerUrl: "https://cihsm-dev-api.cipher.com.ua/signer/api/v1",
    ausigUrl: "https://ccs-dev-api.cipher.com.ua/ccs/ausig/api/v1",
    globalProcessing: false,
    showErrorPopup: false,
    errorData: null,
    showPdfPreviewer: false 
}

const base = (state = baseState, { type, payload }) => {

    switch (type) {

        case 'SET_URLS': {
            return {
                ...state,
                signerUrl: payload.signerUrl || "https://cihsm-dev-api.cipher.com.ua/signer/api/v1",
                ausigUrl: payload.ausigUrl || "https://ccs-dev-api.cipher.com.ua/ccs/ausig/api/v1"
            }
        }

        case 'SET_GLOBAL_PROCESSING': {
            return {
                ...state,
                globalProcessing: payload
            }
        }

        case 'SET_SHOW_ERROR_POPUP': {
            return {
                ...state,
                showErrorPopup: payload
            }
        }

        case 'SET_ERROR_DATA': {
            return {
                ...state,
                errorData: payload
            }
        }

        case 'SET_SHOW_PDF_PREVIEWER': {
            return {
                ...state,
                showPdfPreviewer: payload
            }
        }

        default:
            return state;
    }

}

export default combineReducers({
    base: base,
    createDSReducer: createDSReducer,
    verifyDSReducer: verifyDSReducer
});